import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
import { getActiveCountry } from '@openclassrooms/translations';
import { useGet } from '@openclassrooms/data-connect-web/hooks';
import useCanDisplayMerchandising from '../../_hooks/useCanDisplayMerchandising';
import useUserHasExpectedBenefit from '../../_hooks/useUserHasExpectedBenefit';
import BigInfoBanner from './BigInfoBanner';
import JobOfferBanner from './JobOfferBanner';
export default function BottomBanner(t0) {
  const $ = _c(19);
  let otherProps;
  if ($[0] !== t0) {
    ({
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
  } else {
    otherProps = $[1];
  }
  const canDisplay = useCanDisplayMerchandising();
  const {
    userId
  } = useCurrentUserContext();
  let t1;
  if ($[2] !== userId) {
    t1 = {
      userId
    };
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = Boolean(userId);
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      routeParams: t1,
      enabled: t2,
      queryKey: "userExpectedBenefits"
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data
  } = useGet("/users/:userId/expected-benefits", t3);
  const expectedBenefits = data?.body;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getActiveCountry();
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isUserFrench = t4 === "FR";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["expect_change_career", "expect_boost_career"];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const userExpectsCareerImprovement = useUserHasExpectedBenefit(t5, expectedBenefits);
  const userExpectsFirstJob = useUserHasExpectedBenefit("expect_first_job", expectedBenefits);
  const userHasNoBenefits = !expectedBenefits || expectedBenefits.length === 0;
  const canDisplayApprenticeshipBanner = canDisplay && (userExpectsCareerImprovement || userHasNoBenefits || !isUserFrench);
  const candDisplayJobOfferBanner = canDisplay && userExpectsFirstJob && isUserFrench;
  if (candDisplayJobOfferBanner === undefined || canDisplayApprenticeshipBanner === undefined) {
    return null;
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      my: 5
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== candDisplayJobOfferBanner || $[11] !== otherProps) {
    t7 = candDisplayJobOfferBanner && <JobOfferBanner {...otherProps} />;
    $[10] = candDisplayJobOfferBanner;
    $[11] = otherProps;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== canDisplayApprenticeshipBanner || $[14] !== otherProps) {
    t8 = canDisplayApprenticeshipBanner && <BigInfoBanner {...otherProps} />;
    $[13] = canDisplayApprenticeshipBanner;
    $[14] = otherProps;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <Box sx={t6}>{t7}{t8}</Box>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}